import { z } from "zod";
import { rbimQuestionnairePayloadV1Schema } from "./rbim-questionnaire.js";
export const RBIM_DATA_FILE_TYPE = "RBIM_RECORDS";
export const RBIM_DATA_FILE_VERSION = 1;
export const rbimPortableRecordSchema = z
    .object({
    id: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    syncedAt: z.string().nullable().optional(),
    municipalityCode: z.string().optional(),
    barangayCode: z.string().optional(),
    purokCode: z.string().optional(),
    cleanedData: z.record(z.string(), z.unknown()).optional().default({}),
    rawData: rbimQuestionnairePayloadV1Schema,
})
    .passthrough();
export const rbimDataFileSchema = z
    .object({
    fileType: z.literal(RBIM_DATA_FILE_TYPE),
    version: z.literal(RBIM_DATA_FILE_VERSION),
    kind: z.enum(["export", "backup"]),
    createdAt: z.string(),
    records: z.array(rbimPortableRecordSchema),
})
    .strict();
//# sourceMappingURL=rbim-data-transfer.js.map